import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderDeliveryButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={`https://www.doordash.com/store/jl-sushi-kitchen-north-vancouver-163848/?utm_campaign=gpa`}
            >
              <CFView hover>
                <CFImage
                  src={orderDeliveryButton}
                  maxWidth="280px"
                  alt="About"
                />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={`https://www.doordash.com/store/jl-sushi-kitchen-north-vancouver-163848/?utm_campaign=gpa`}
            >
              <CFView hover>
                <CFImage
                  src={orderDeliveryButton}
                  maxWidth="310px"
                  alt="About"
                />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
